// config.js

const bizIcon = "https://metroplexbestroofing.com/wp-content/uploads/2024/10/cropped-Logo_Legaroof_2.png";
const imageOne = "https://metroplexbestroofing.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-29-at-3.10.08-PM-e1730728624589.jpeg";
const imageTwo = "https://metroplexbestroofing.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-29-at-5.00.08-PM.jpeg";
const imageThree = "https://metroplexbestroofing.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-29-at-4.44.21-PM-2.jpeg";
const imageFour = "https://metroplexbestroofing.com/wp-content/uploads/2024/11/WhatsApp-Image-2024-11-04-at-4.32.27-PM-1024x682.jpeg";
const imageFive = "https://metroplexbestroofing.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-29-at-4.47.16-PM.jpeg";

const socialMediaLink = 'https://metroplexbestroofing.com/';

export const siteConfig = {
  title: "Metroplex Best Roofing Systems",
  metaDescription: "Metroplex Best Roofing Systems",
  theme: {
    primaryColor: "red-500",
    secondaryColor: "gray-200",
    accentColor: "text-red-500"
  },
  logo: {
    src: bizIcon,
    alt: "Metroplex Best Roofing Systems",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Metroplex Best Roofing Systems",
    headline: "Your One-Stop Shop For All Your Roofing Needs.",
    address: "732 W Hurst Blvd Ste 102, Hurst, TX 76053",
    description: "Quality roofing services for your lovely home."
  },
  images: {
    business: {
      src: imageOne,
      alt: "Premium Roofing Services",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 
        "We are a licensed and insured full-service roofing company specializing in roof installation, inspection, maintenance, repair, and replacement. We also handle roof insurance claims and storm damage restoration, ensuring your peace of mind. As an A+ Rated, BBB Accredited Contractor, we are committed to delivering exceptional service."
    },
    {
      description: 
        "Our expert team is dedicated to providing top-notch roofing solutions, including inspections, repairs, maintenance, and replacements. We specialize in restoring roofs affected by wind, hail, and storm damage, ensuring long-lasting protection for your home or business."
    },
    {
      description: 
        "Metroplex Best Roofing Systems is your trusted partner for reliable and affordable roofing services in Texas. Contact us today for quick, dependable solutions tailored to your needs."
    }
  ],
  services: {
    sectionTitle: "Our Excellent Roofing Services",
    description: "We take the hassle out of roof repairs and replacements. From managing your insurance claims to ensuring high-quality workmanship, we’re here to make the process seamless and stress-free, so you can focus on what matters most.",
    callouts: [
      {
        name: 'Roof Installation',
        description: 'Expertly install durable, high-quality roofing systems to protect your home or business.',
        imageSrc: imageTwo,
        imageAlt: 'A professional roofing team working on a new installation',
      },
      {
        name: 'Roof Replacement',
        description: 'Replace old or damaged roofs with modern, reliable materials designed to last.',
        imageSrc: imageThree,
        imageAlt: 'A finished roof replacement showcasing sleek shingles',
      },
      {
        name: 'Roof Damage Restoration',
        description: 'Restore roofs impacted by storms, hail, and other weather damage with precision.',
        imageSrc: imageFour,
        imageAlt: 'A roof being repaired after storm damage',
      }
    ],
    otherServices: [
      "Roof Repair",
      "Roof Maintenance",
      "Insurance Claim Assistance",
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: "At Metroplex Best Roofing Systems, we make the process of working with your insurance company simple and painless. We do this while working on your behalf to ensure you receive all the money that is owed to you for damages to your home and to cover your replacement costs.",
    image: {
      src: imageFive,
      alt: "Metroplex Best Roofing team in action",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "732 W Hurst Blvd Ste 102, Hurst, TX 76053, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3352.320157182503!2d-97.1808583!3d32.8232179!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7cf5c27e0d5d%3A0x39c6c4f9b5c38ffb!2s732%20W%20Hurst%20Blvd%20Ste%20102%2C%20Hurst%2C%20TX%2076053%2C%20USA!5e0!3m2!1sen!2sph!4v1710407450828!5m2!1sen!2sph",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=732%20W%20Hurst%20Blvd%20Ste%20102,%20Hurst,%20TX%2076053&ll=32.8232179,-97.1808583&q=732%20W%20Hurst%20Blvd%20Ste%20102,%20Hurst,%20TX%2076053' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=732+W+Hurst+Blvd+Ste+102,+Hurst,+TX+76053&form=HDRSC6&sp=1&pq=732+w+hurst+blvd+ste+102,+hurst,+tx+76053&sc=0-0&qs=n&sk=&cvid=EDFC0FE5A0E74E8DB130342A842AA10C' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/732+W+Hurst+Blvd+Ste+102,+Hurst,+TX+76053,+USA/@32.8232179,-97.1808583,15.26523397a,814.57589625d,35y,0h,0t,0r' },
      { name: 'Google Maps', url: 'https://maps.app.goo.gl/4Y2YfHGWxgrC8tTE7' }
    ]
  },  
  contact: {
    sectionTitle: "Contact us to find out why you should work with us for your Roofing Insurance Claim.",
    description: "Are you making a roof insurance claim in Texas? Work with the team at Metroplex Best Roofing Systems. Give us a call today for your free, no-obligation estimate.",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["682-970-9881"],
    logo: bizIcon,
    emailRecipient: "goshenroof@gmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
